import { useEnv } from '@btcdirect/shared/src/composables/util/env';
import { UNIFIED_CHECKOUT } from '../../../../.scripts/projects';

const { getString } = useEnv();

export const isUnifiedCheckoutURL = (url: string) => {
    const isCheckoutURL = /^http(s)?:\/\/checkout(-sandbox|-stage)?\.btcdirect\.(eu|dev)/.test(url);

    if ('development' === getString('NODE_ENV', 'development')) {
        return url.includes(UNIFIED_CHECKOUT.port.toString()) || isCheckoutURL;
    }

    return isCheckoutURL;
};
